let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3h8IX")).then(() => parcelRequire('5WZq1'));